// extracted by mini-css-extract-plugin
export default {"header":"page_header__WVQr6","title":"page_title__S0rox","nav":"page_nav__mXo9Y"};